<template>
    <div class="page-box">
            <el-form ref="ruleForm" :model="form"  label-width="180px">
                <el-form-item label="Template Tittle" 
                 prop="title"
                 :rules="[
                    { required: true, message: 'The Template Title field is required', trigger: 'blur'},
                    ]">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-divider>Email Template</el-divider>
                <el-form-item label="Subject" :prop="'email.subject'" :rules="[
                    { required: true, message: 'The Subject field is required.', trigger: 'blur'},
                    ]">
                        <el-input v-model="form.email.subject"></el-input>
                    </el-form-item>
                <el-form-item label="Body" :prop="'email.body'" :rules="[
                    { required: true, message: 'The Body field is required.', trigger: 'blur'},
                    ]">
                    <tinymceVue :key="tinymceIndex1" v-model="form.email.body"></tinymceVue>
                    </el-form-item>
                    <el-divider>Announcement Template</el-divider>
                <el-form-item label="Subject" :prop="'announcement.subject'" :rules="[
                    { required: true, message: 'The Subject field is required.', trigger: 'blur'},
                    ]">
                        <el-input v-model="form.announcement.subject"></el-input>
                    </el-form-item>
                <el-form-item label="Body" :prop="'announcement.body'" :rules="[
                    { required: true, message: 'The Body field is required.', trigger: 'blur'},
                    ]">
                    <tinymceVue :key="tinymceIndex"  v-model="form.announcement.body"></tinymceVue>
                </el-form-item>
            </el-form>
    </div>
</template>

<script>
    import tinymceVue from '@/components/tinymceVue'
    export default {
        components:{tinymceVue},
          props:{
            form:{
                type:Object,
                default:function(){}
            }
        },
        mounted(){
            setTimeout(()=>{
                this.tinymceIndex1++
                this.tinymceIndex++
            },1000)
        },
        data() {
            return {
              tinymceIndex1:0,
              tinymceIndex:0
            }
        },
    }
</script>

<style lang="scss" scoped>
.page-box{
    background-color: #fff;
    padding: 20px;
}
.el-divider__text{
   font-size:20px;
   font-weight:400; 
}
</style>